/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import { Button } from 'edrolo-style-guide';
import style from './ExportCSVButton.scss';

const ExportCSVButton = ({ csvExportUrl, onClick }) => {
  return (
    <div className={style.container}>
      <Button
        outline
        aria-controls="csv-export-button"
        className={cx(style.exportCSVButton)}
        onClick={onClick}
      >
        <a
          href={csvExportUrl}
          target="_blank"
          className={cx(style.downloadLink)}
        >
          Export (CSV)
          <span className={style.downloadIcon}>
            <i className="icon-download" />
          </span>
        </a>
      </Button>
    </div>
  );
};

export default ExportCSVButton;
